import key from 'weak-key';
import { Typo } from '@geberit/gdds';

// styles
import styles from '../text-image.module.scss';
import { textStyle } from '..';

// types
import type { MediaProps, ImageVideoProps } from '../text-image.types';

// components
import HoverImage from 'components/image/hover-image';
import { MiVideoContainer } from 'components/Video/miVideo/MiVideoContainer';
import ConfigurableYoutube from 'components/Video/youtube/configurable-youtube';
import VideoPreviewPlaceholder from 'components/ContentElementsGdds/video/video-preview-placeholder';
import { useIsMobile } from 'components/App/SizeProvider';

// utils
import { decodingContent } from 'utils/decodingContent';
import { isEmpty } from 'utils/is-empty';
import { useUCConsent, VideoConsent } from 'features/cookie-consent';
import { isVideoItem } from 'components/ContentElementsGdds/TextImage/utils';

function ImageVideo({
  media,
  toggleVideoModal,
  onlyImages = false,
  onlyVideos = false,
}: Readonly<ImageVideoProps>) {
  const isMobile = useIsMobile();
  const ucConsent = useUCConsent();

  if (isEmpty(media)) return null;

  return media.map((item: MediaProps) => {
    const isYoutube = item?.video?.type === 'youtube';
    const image =
      isMobile && item.imageObjectMobile?.url ? item.imageObjectMobile : item.imageObject;
    const isVideo = isVideoItem(item);

    if (!(((onlyImages && !isVideo) || !onlyImages) && ((onlyVideos && isVideo) || !onlyVideos))) {
      return null;
    }

    return (
      <div key={key(item)} className={styles.singleMedia}>
        {isVideo && (
          <>
            {toggleVideoModal ? (
              <>
                {ucConsent.Comfort === true && (
                  <VideoPreviewPlaceholder
                    videoPreviewImage={item?.video?.videoPreviewImage}
                    youtubePlaceholder={image as ImageObject}
                    playButton={() => toggleVideoModal(item?.video as VideoProp)}
                    className="media-column-video"
                  />
                )}
                {ucConsent.Comfort === false &&
                  (isYoutube ? <VideoConsent type="youtube" /> : <VideoConsent type="mi24" />)}
              </>
            ) : (
              <>
                {item?.video?.type === 'youtube' ? (
                  <ConfigurableYoutube
                    videoId={item?.video?.videoId}
                    playerControl={item?.video?.playerControl}
                    language={item?.video?.language}
                    showLink={item?.video?.showLink}
                  />
                ) : (
                  <MiVideoContainer className="c-text-video" content={{ video: item?.video }} />
                )}
              </>
            )}
          </>
        )}
        {isVideo === false && (
          <HoverImage
            images={[
              {
                ...item,
                pictureObject: item.imageObject!,
                imgResolutionsPicture: item.imgResolutionsPicture || '1_1',
              },
            ]}
          />
        )}
        {item.caption && (
          <Typo tag="div" size={textStyle.caption} className={styles.caption}>
            {decodingContent(item.caption)}
          </Typo>
        )}
      </div>
    );
  });
}

export default ImageVideo;
